module.exports = __webpack_public_path__ + "img/gotfertomi-divers-6.9b92837f.jpg";